/**
 *  Management of Application State
 */
import Vue from 'vue'
import Vuex from 'vuex'
import MyColors from "@/plugins/MyColors"

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    FAKTURA_FAKTURA	:	1,
    FAKTURA_STORNO  :	2,
    FAKTURA_GUTSCHRIFT	:	3,
    FAKTURA_LIEFERSCHEIN : 4,
    FAKTURA_VERBUCHT	:	5,
    FAKTURA_RAPPORT	:	6,
    FAKTURA_OFFEN	:	1,
    FAKTURA_OFFERTE : 8,
    FAKTURA_AUFTRAG : 9,
    FAKTURA_ARCHIV : 11,
    
    // colors
    stdColorLight: MyColors.stdColorLight,
    stdColorDark: MyColors.stdColorDark,
    stdColorMasterDetail: MyColors.stdColorMasterDetail,
    stdColorSelectedRow: MyColors.stdColorSelectedRow,
    colorSystemBarOn: MyColors.colorSystemBarOn,
    colorSystemBarOff: MyColors.colorSystemBarOff,

    // system bar
    systemBarColor: MyColors.colorSystemBarOff,

    // selected language
    selectedLanguage: null,

    // router views in App
    routerViewToolbar: 'appToolbar',
    routerViewContent: 'appContent',

    // navigation
    navigationDrawer: {
      permanent: true,
      drawer: true
    },

    taxCode: 1,

    // master data states
    masterDataState: {
      showCustomer: false,
      showProduct: false,
      showService: false,
      showLieferadresse: false,
      showLieferant: false,
      showWeingang: false,
      showFaktura: false,
      showFakturaPos: false,
      showAuftrag: false,
      showAuftragPos: false,
      showOfferte: false,
      showOffertePos: false,
      showRapport: false,
      showRapportPos: false,
      showFakturaVerbucht: false,
      showFakturaArchiv: false,
      showTax: false,
      showWgruppe: false,
      showRabatt: false,
      showKondition: false,
      showFzeile: false,
      showMahntext: false,
      showBankkonto: false,
      showUser: false
    },

    // entity lists
    customerList: [],
    productList: [],
    serviceList: [],
    taxList: [],
    wgruppenList: [],
    rabattList: [],
    lieferadresseList: [],
    lieferantenList: [],
    weingangList: [],
    fakturaList: [],
    auftragList: [],
    offerteList: [],
    rapportList: [],
    konditionList: [],
    fzeileList: [],
    mahntextList: [],
    bankkontoList: [],
    userList: [],

    // states of logon
    user: null,

    actualUser: {
      username: "",
      password: ""
    },

    isLoggedOn: false,

    //confirm dialog
    confirmDialog: {
      showConfirmDialog: false,
      message: "",
      action: null,
      params: []
    },

    //error dialog
    errorDialog: {
      showErrorDialog: false,
      sqlCode: 0,
      sqlState: "",
      sqlMessage: "",
      myErrorCode: 0
    },

    //report
    report: {
      showReport: false,
      name: "",
      title: "",
      reportData: {
        name: "",
        outputType: "HTML",
        inputType: "LIST",
        parameters: [],
        dataSets: [],
        images: []
      }
    },

    //help
    showHelpList: false,

    //register
    showRegisterProcess: false,

    //REST API
    login: 'users/login',
    getUser: 'users',
    getUserNoAuth: 'users/noauth',
    resetSchema: 'admin/reset',
    rebuildData: 'admin/demodata',
    createLogEntry: 'log',
    getReport: 'reporting/birt/reports',
    reloadReports: 'reporting/birt/reports/reload',
    redeployReports: 'reporting/birt/reports/redeploy',
    issueNewPassword: 'users/noauth/newpassword',
    setNewPassword: 'users/newpassword',
    insertUser: 'users/noauth',

    //REST API (entities)
    customersBase: 'entities/kunden',
    productsBase: 'entities/artikel',
    servicesBase: 'entities/leistungen',
    taxesBase: 'entities/tax',
    wgruppenBase: 'entities/wgruppen',
    rabatteBase: 'entities/rabatte',
    lieferadresseBase: 'entities/lieferadressen',
    lieferantBase: 'entities/lieferanten',
    weingangBase: 'entities/wareneingang',
    fakturaBase: 'entities/faktura',
    fakturaEntities: 'entities/faktura/type',
    auftragBase: 'entities/auftraege',
    offerteBase: 'entities/offerten',
    rapportBase: 'entities/rapporte',
    konditionenBase: 'entities/konditionen',
    fzeileBase: 'entities/faktzeilen',
    mahntextBase: 'entities/mahntexte',
    bankkontoBase: 'entities/bankkonto',
    userBase: 'users',
    paramsBase: 'entities/params',
    calcInvoice: 'entities/faktura/calc',
    calcInvoiceItem: 'entities/fakturapos/calc',
    changeRapportToFaktura: 'entities/rapporte/changetofaktura',
    changeOfferteToAuftrag: 'entities/offerten/changetoauftrag',
    changeAuftragToFaktura: 'entities/auftraege/changetofaktura',
    changeFakturaToArchiv: 'entities/faktura/changetoarchiv',
    changeFakturaToPaid: 'entities/faktura/changetopaid',
    getQRSlips: 'entities/faktura/qr/slips',
    cloneFaktura: 'entities/faktura/clone',
    setPrintStatus: 'entities/faktura/setprintstatus',
    clearPrintStatus: 'entities/faktura/clearprintstatus',
    cloneInvoiceItem: 'entities/fakturapos/clone',
  },

  mutations: {
    SET_SYSTEMBAR_COLOR(state, systemBarColor) {
      state.systemBarColor = systemBarColor
    },

    SET_NAVIGATION_DAWER(state, visible) {
      state.navigationDrawer.drawer = visible
    },

    SET_NAVIGATION_DAWER_PERMANENT(state, permanent) {
      state.navigationDrawer.permanent = permanent
    },

    SET_SELECTEDLANGUAGE(state, selectedLanguage) {
      state.selectedLanguage = selectedLanguage
    },

    SET_ROUTERVIEW_TOOLBAR(state, routerViewToolbar) {
      state.routerViewToolbar = routerViewToolbar
    },

    SET_ROUTERVIEW_CONTENT(state, routerViewContent) {
      state.routerViewContent = routerViewContent
    },

    SET_TAXCODE(state, taxCode) {
      state.taxCode = taxCode
    },

    SET_CUSTOMER_LIST(state, customerList) {
      state.customerList = customerList
    },

    SET_PRODUCT_LIST(state, productList) {
      state.productList = productList
    },

    SET_SERVICE_LIST(state, serviceList) {
      state.serviceList = serviceList
    },

    SET_TAX_LIST(state, taxList) {
      state.taxList = taxList
    },

    SET_WGRUPPEN_LIST(state, wgruppenList) {
      state.wgruppenList = wgruppenList
    },

    SET_RABATT_LIST(state, rabattList) {
      state.rabattList = rabattList
    },

    SET_LIEFERADRESSE_LIST(state, lieferadresseList) {
      state.lieferadresseList = lieferadresseList
    },

    SET_LIEFERANTEN_LIST(state, lieferantenList) {
      state.lieferantenList = lieferantenList
    },

    SET_WEINGANG_LIST(state, weingangList) {
      state.weingangList = weingangList
    },

    SET_FAKTURA_LIST(state, fakturaList) {
      state.fakturaList = fakturaList
    },

    SET_AUFTRAG_LIST(state, auftragList) {
      state.auftragList = auftragList
    },

    SET_OFFERTE_LIST(state, offerteList) {
      state.offerteList = offerteList
    },

    SET_RAPPORT_LIST(state, rapportList) {
      state.rapportList = rapportList
    },

    SET_KONDITION_LIST(state, konditionList) {
      state.konditionList = konditionList
    },

    SET_FZEILE_LIST(state, fzeileList) {
      state.fzeileList = fzeileList
    },

    SET_MAHNTEXT_LIST(state, mahntextList) {
      state.mahntextList = mahntextList
    },

    SET_BANKKONTO_LIST(state, bankkontoList) {
      state.bankkontoList = bankkontoList
    },

    SET_USER_LIST(state, userList) {
      state.userList = userList
    },

    SET_USER(state, user) {
      state.user = user
    },

    SET_ACTUALUSER(state, actualUser) {
      //we do not want the reference but a clone of the object
      state.actualUser=Object.assign({}, actualUser);
    },

    SET_LOGGED_ON(state, isLoggedOn) {
      state.isLoggedOn = isLoggedOn
    },

    SET_HELPLIST_STATE(state, showHelpList) {
      state.showHelpList = showHelpList
    },

    SET_REGISTER_STATE(state, showRegisterProcess) {
      state.showRegisterProcess = showRegisterProcess
    },

    SET_CONFIRMDIALOG_STATE(state, confirmDialog) {
      state.confirmDialog.message = confirmDialog.message
      state.confirmDialog.action = confirmDialog.action
      state.confirmDialog.params = confirmDialog.params
      state.confirmDialog.showConfirmDialog = confirmDialog.showConfirmDialog
    },

    SET_ERRORDIALOG_STATE(state, errorDialog) {
      state.errorDialog.sqlCode = errorDialog.sqlCode
      state.errorDialog.sqlState = errorDialog.sqlState
      state.errorDialog.sqlMessage = errorDialog.sqlMessage
      state.errorDialog.myErrorCode = errorDialog.myErrorCode
      state.errorDialog.showErrorDialog = errorDialog.showErrorDialog
    },

    SET_REPORT_STATE(state, report) {
      state.report=Object.assign({}, report);
    },

    SET_MASTERDATA_STATE(state, masterDataState) {
      state.masterDataState = masterDataState
    }

  },

  actions: {
    setSystemBarColor(context, systemBarColor) {
      context.commit("SET_SYSTEMBAR_COLOR", systemBarColor)
    },

    setNavigationDrawer(context, visible) {
      context.commit("SET_NAVIGATION_DAWER", visible)
    },

    setNavigationDrawerPermanent(context, permanent) {
      context.commit("SET_NAVIGATION_DAWER_PERMANENT", permanent)
    },

    setSelectedLanguage(context, selectedLanguage) {
      context.commit("SET_SELECTEDLANGUAGE", selectedLanguage)
    },

    setRouterViewToolbar(context, routerViewToolbar) {
      context.commit("SET_ROUTERVIEW_TOOLBAR", routerViewToolbar)
    },

    setRouterViewContent(context, routerViewContent) {
      context.commit("SET_ROUTERVIEW_CONTENT", routerViewContent)
    },

    setTaxCode(context, taxCode) {
      context.commit("SET_TAXCODE", taxCode)
    },

    setCustomerList(context, customerList) {
      context.commit("SET_CUSTOMER_LIST", customerList)
    },

    setProductList(context, productList) {
      context.commit("SET_PRODUCT_LIST", productList)
    },

    setServiceList(context, serviceList) {
      context.commit("SET_SERVICE_LIST", serviceList)
    },

    setTaxList(context, taxList) {
      context.commit("SET_TAX_LIST", taxList)
    },

    setWgruppenList(context, wgruppenList) {
      context.commit("SET_WGRUPPEN_LIST", wgruppenList)
    },

    setRabattList(context, rabattList) {
      context.commit("SET_RABATT_LIST", rabattList)
    },

    setLieferadresseList(context, lieferadresseList) {
      context.commit("SET_LIEFERADRESSE_LIST", lieferadresseList)
    },

    setLieferantenList(context, lieferantenList) {
      context.commit("SET_LIEFERANTEN_LIST", lieferantenList)
    },

    setWeingangList(context, weingangList) {
      context.commit("SET_WEINGANG_LIST", weingangList)
    },

    setFakturaList(context, fakturaList) {
      context.commit("SET_FAKTURA_LIST", fakturaList)
    },

    setAuftragList(context, auftragList) {
      context.commit("SET_AUFTRAG_LIST", auftragList)
    },

    setOfferteList(context, offerteList) {
      context.commit("SET_OFFERTE_LIST", offerteList)
    },

    setRapportList(context, rapportList) {
      context.commit("SET_RAPPORT_LIST", rapportList)
    },

    setKonditionList(context, konditionList) {
      context.commit("SET_KONDITION_LIST", konditionList)
    },

    setFzeileList(context, fzeileList) {
      context.commit("SET_FZEILE_LIST", fzeileList)
    },

    setMahntextList(context, mahntextList) {
      context.commit("SET_MAHNTEXT_LIST", mahntextList)
    },

    setBankkontoList(context, bankkontoList) {
      context.commit("SET_BANKKONTO_LIST", bankkontoList)
    },

    setUserList(context, userList) {
      context.commit("SET_USER_LIST", userList)
    },

    setUser(context, user) {
      context.commit("SET_USER", user)
    },

    setActualUser(context, actualUser) {
      context.commit("SET_ACTUALUSER", actualUser)
    },

    setLoggedOn(context, isLoggedOn) {
      context.commit("SET_LOGGED_ON", isLoggedOn)
    },

    setShowHelpList(context, showHelpList) {
      context.commit("SET_HELPLIST_STATE", showHelpList)
    },

    setShowRegisterProcess(context, showRegisterProcess) {
      context.commit("SET_REGISTER_STATE", showRegisterProcess)
    },

    setConfirmDialog(context, confirmDialog) {
      context.commit("SET_CONFIRMDIALOG_STATE", confirmDialog)
    },

    setErrorDialog(context, errorDialog) {
      context.commit("SET_ERRORDIALOG_STATE", errorDialog)
    },

    setReport(context, report) {
      context.commit("SET_REPORT_STATE", report)
    },

    setMasterDataState(context, masterDataState) {
      context.commit("SET_MASTERDATA_STATE", masterDataState)
    }

  },

  getters: {
    systemBarColor: state => state.systemBarColor,

    // get selected language
    selectedLanguage: state => state.selectedLanguage,

    // get state of routerViewToolbar
    routerViewToolbar: state => state.routerViewToolbar,

    // get state of routerViewContent
    routerViewContent: state => state.routerViewContent,

    taxCode: state => state.taxCode,

    // get entity data
    customerList: state => state.customerList,
    productList: state => state.productList,
    serviceList: state => state.serviceList,
    taxList: state => state.taxList,
    wgruppenList: state => state.wgruppenList,
    rabattList: state => state.rabattList,
    lieferadresseList: state => state.lieferadresseList,
    lieferantenList: state => state.lieferantenList,
    weingangList: state => state.weingangList,
    fakturaList: state => state.fakturaList,
    auftragList: state => state.auftragList,
    offerteList: state => state.offerteList,
    rapportList: state => state.rapportList,
    konditionList: state => state.konditionList,
    fzeileList: state => state.fzeileList,
    mahntextList: state => state.mahntextList,
    bankkontoList: state => state.bankkontoList,
    userList: state => state.userList,

    // get current user
    user: state => state.user,
    username: state => state.actualUser.username,
    password: state => state.actualUser.password,
    actualUser: state => state.actualUser,

    // get current logon state
    isLoggedOn: state => state.isLoggedOn,

    // confirm dialog
    showConfirmDialog: state => state.confirmDialog.showConfirmDialog,
    confirmDialog: state => state.confirmDialog,

    // error dialog
    showErrorDialog: state => state.errorDialog.showErrorDialog,
    errorDialog: state => state.errorDialog,

    // report
    showReport: state => state.report.showReport,
    report: state => state.report,

    // help
    showHelpList: state => state.showHelpList,

    // register
    showRegisterProcess: state => state.showRegisterProcess,

    // master data
    masterDataState: state => state.masterDataState,
    showCustomer: state => state.masterDataState.showCustomer,
    showProduct: state => state.masterDataState.showProduct,
    showService: state => state.masterDataState.showService,
    showTax: state => state.masterDataState.showTax,
    showWgruppe: state => state.masterDataState.showWgruppe,
    showLieferadresse: state => state.masterDataState.showLieferadresse,
    showLieferant: state => state.masterDataState.showLieferant,
    showWeingang: state => state.masterDataState.showWeingang,
    showFaktura: state => state.masterDataState.showFaktura,
    showFakturaPos: state => state.masterDataState.showFakturaPos,
    showAuftrag: state => state.masterDataState.showAuftrag,
    showAuftragPos: state => state.masterDataState.showAuftragPos,
    showOfferte: state => state.masterDataState.showOfferte,
    showOffertePos: state => state.masterDataState.showOffertePos,
    showRapport: state => state.masterDataState.showRapport,
    showRapportPos: state => state.masterDataState.showRapportPos,
    showFakturaVerbucht: state => state.masterDataState.showFakturaVerbucht,
    showFakturaArchiv: state => state.masterDataState.showFakturaArchiv,
    showRabatt: state => state.masterDataState.showRabatt,
    showKondition: state => state.masterDataState.showKondition,
    showFzeile: state => state.masterDataState.showFzeile,
    showMahntext: state => state.masterDataState.showMahntext,
    showBankkonto: state => state.masterDataState.showBankkonto,
    showUser: state => state.masterDataState.showUser,

    // getters for optimaw REST API
    login: state => state.login,
    getUser: state => state.getUser,
    getUserNoAuth: state => state.getUserNoAuth,
    resetSchema: state => state.resetSchema,
    rebuildData: state => state.rebuildData,
    createLogEntry: state => state.createLogEntry,
    getReport: state => state.getReport,
    reloadReports: state => state.reloadReports,
    redeployReports: state => state.redeployReports,
    issueNewPassword: state => state.issueNewPassword,
    setNewPassword: state => state.setNewPassword,
    insertUser: state => state.insertUser,

    // getters for optimaw REST API (entities)
    customersBase: state => state.customersBase,
    productsBase: state => state.productsBase,
    servicesBase: state => state.servicesBase,
    taxesBase: state => state.taxesBase,
    wgruppenBase: state => state.wgruppenBase,
    rabatteBase: state => state.rabatteBase,
    lieferadresseBase: state => state.lieferadresseBase,
    lieferantBase: state => state.lieferantBase,
    weingangBase: state => state.weingangBase,
    fakturaBase: state => state.fakturaBase,
    fakturaEntities: state => state.fakturaEntities,
    auftragBase: state => state.auftragBase,
    offerteBase: state => state.offerteBase,
    rapportBase: state => state.rapportBase,
    konditionenBase: state => state.konditionenBase,
    fzeileBase: state => state.fzeileBase,
    mahntextBase: state => state.mahntextBase,
    bankkontoBase: state => state.bankkontoBase,
    userBase: state => state.userBase,
    paramsBase: state => state.paramsBase,
    calcInvoice: state => state.calcInvoice,
    calcInvoiceItem: state => state.calcInvoiceItem,
    changeRapportToFaktura: state => state.changeRapportToFaktura,
    changeOfferteToAuftrag: state => state.changeOfferteToAuftrag,
    changeAuftragToFaktura: state => state.changeAuftragToFaktura,
    changeFakturaToArchiv: state => state.changeFakturaToArchiv,
    changeFakturaToPaid: state => state.changeFakturaToPaid,
    getQRSlips: state => state.getQRSlips,
    cloneFaktura: state => state.cloneFaktura,
    setPrintStatus: state => state.setPrintStatus,
    clearPrintStatus: state => state.clearPrintStatus,
    cloneInvoiceItem: state => state.cloneInvoiceItem,

    //getters for colors:
    stdColorLight: state => state.stdColorLight,
    stdColorDark: state => state.stdColorDark,
    colorSystemBarOn: state => state.colorSystemBarOn,
    colorSystemBarOff: state => state.colorSystemBarOff,
    stdColorMasterDetail: state => state.stdColorMasterDetail,
    stdColorSelectedRow: state => state.stdColorSelectedRow,

    //getters for faktura states:
    FAKTURA_FAKTURA: state => state.FAKTURA_FAKTURA,
    FAKTURA_STORNO: state => state.FAKTURA_STORNO,
    FAKTURA_GUTSCHRIFT: state => state.FAKTURA_GUTSCHRIFT,
    FAKTURA_LIEFERSCHEIN: state => state.FAKTURA_LIEFERSCHEIN,
    FAKTURA_VERBUCHT: state => state.FAKTURA_VERBUCHT,
    FAKTURA_RAPPORT: state => state.FAKTURA_RAPPORT,
    FAKTURA_OFFEN: state => state.FAKTURA_OFFEN,
    FAKTURA_OFFERTE: state => state.FAKTURA_OFFERTE,
    FAKTURA_AUFTRAG: state => state.FAKTURA_AUFTRAG,
    FAKTURA_ARCHIV: state => state.FAKTURA_ARCHIV
  }
})
